<template>
  <div :class="{'modal':true, 'is-active':show}">

    <div class="modal-background" @click="$emit('close-modal')"></div>
    <div class="modal-card">
        <div class="box has-text-centered">
            <table class="table is-fullwidth is-striped is-hoverable" v-if="loaded">
                <thead>
                    <tr>
                        <th class="has-text-left">Jugador</th>
                        <th>Mapa</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(p,n) in players" :key="n">
                        <td class="td-name has-text-left">
                            <!-- GREMIO -->
                            <small v-if="p.guild_detail" class="has-text-primary">
                                [ <fa icon="crown" v-if="p.guild_detail.is_master" v-tooltip="{ content: 'Maestro de Gremio' }" /> {{p.guild_detail.guild.name}} ]&nbsp;
                            </small>
                            <!-- NOMBRE -->
                            <span :class="{
                                'has-text-warning-dark':p.pkcount == 1,
                                'has-text-danger-dark':p.pkcount > 1, 
                                'has-text-link-dark':p.pkcount < -1, 
                                'has-text-info':p.pkcount == -1
                            }">
                                <b>{{p.name}}</b>
                            </span>
                            <!-- VIP BADGE -->
                            <small v-if="p.isvip > 0" class="has-text-link">&nbsp;<fa icon="award" /> VIP</small>
                        </td>
                        <td>{{mapName(p.mapnumber)}}</td>
                    </tr>
                </tbody>
            </table>
            <fa v-else icon="circle-notch" class="fa-3x" spin />
        </div>

    </div>

  </div>
</template>

<script>
// import PlayerService from '@/services/player.service.js';
export default {
    name:'OnlineModals',
    props: {
        show: {
            default:false,
            type:Boolean
        }
    },
    computed: {
        mapName() {
            return this.$store.getters.GetMapName
        }
    },
    data:()=>({
        loaded:false,
        players:[]
    }),
    async created() {
        this.makeUp()
    },
    methods: {
        async makeUp() {
            this.loaded = false
            // let {data} = await PlayerService.GetOnlinePlayers()
            let data = this.$store.getters.GetJson('players')
            this.players = data.results.filter(player => player.is_online == true)
            this.loaded = true
        }
    }
}
</script>

<style scoped>
    .modal-card {
        overflow: auto !important;
    }

</style>